module.exports = __webpack_public_path__ + "static/media/carousel1.facc1424.webp";